
import AjaxPlugin from 'vux/src/plugins/ajax/index.js'
import Alert from 'vux/src/components/alert/index.vue'
import Card from 'vux/src/components/card/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import ChinaAddressV4Data from 'vux/src/datas/china_address_v4.json'
import Confirm from 'vux/src/components/confirm/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Selector from 'vux/src/components/selector/index.vue'
import Toast from 'vux/src/components/toast/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import value2name from 'vux/src/filters/value2name.js'
import XAddress from 'vux/src/components/x-address/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import XTextarea from 'vux/src/components/x-textarea/index.vue'

import wx from 'weixin-js-sdk'
import global_ from './global'

export default {
data() {
return {
num: 6,
imgRepairList: [],
router: '',
buttonText: '发送验证码',
smsDisabled: false,
isSend: false,
code: '',
fastrepairshow: false,
reptype: '最终用户报修',
reptypelist: [{key: '最终用户报修', value: '最终用户报修'}, {key: '服务商代报修', value: '服务商代报修'}, {key: '其他代报修', value: '其他代报修'}],
enduser: '',
endmobile: '',
lservice: '',
lsmobile: '',
save_info: this.$route.params.save_info,
isviwo: this.$route.params.isviwo ? '是' : '否',
sevenday: false,
devseq: "",
devname: "",
devmodel: '',
userInfo: {},
producer: '',
buyfrom: "",
company: '',
ftype: '使用问题',
name: '',
mobile: '',
fdesc: "",
showLoading: false,
imgList: {
version: '1.1',
content: []
},
size: 0,
starttime: '',
endtime: '',
img1: '/static/img/idcard1.png',
imgUrl: '/static/img/flick.png',
photo: {'path': '', 'serverid': ''},
account: '',
username: '',
sequence: '',

title: '默认为空',
value_0_1: [],
value: [],
title2: '设置值',
value2: ['天津市', '市辖区', '和平区'],
value3: ['广东省', '中山市', '--'],
addressData: ChinaAddressV4Data,
value4: [],
value5: ['广东省', '深圳 市', '南山区'],
showAddress: false,
address: [],
address2: '',
token: '',
eduList: [{key: 1, value: '设备启动故障'}, {key: 2, value: '设备死机故障'}, {key: 3, value: '设备显示故障'}, {
key: 4,
value: '设备识别故障'
}, {key: 5, value: '设备输入输出故障'}, {key: 6, value: '设备音频故障'}, {key: 7, value: '设备其他故障'}],
boolList: [{key: true, value: '是'}, {key: false, value: '否'}],
viwoList: [{key: true, value: '是'}, {key: false, value: '否'}],
ject: {},
role: '',
isid: '',
isProducer: false,
producerList: [],
isFastReapir: true,
vwarranty: '',
list1: ['使用问题', '软件问题', '运输问题', '硬件问题', '其他问题'],
show: true
}
},
components: {XInput, Group, XTextarea, XAddress, Card, Alert, Cell, Selector, XButton, Toast, Confirm},
directives: {TransferDom},
methods: {
isCheck() {
if (this.address.length === 0) {
this.$vux.alert.show({
content: '请填写设备所在地',
type: 'cancel'
})
return
}
var address = {
address1: value2name(this.address, ChinaAddressV4Data),
address2: this.address2
}
address.address1 = address.address1.split(' ')
if (!this.devseq) {
this.$vux.alert.show({
content: '请填写序列号',
type: 'cancel'
})
return
}
if (!this.devname) {
this.$vux.alert.show({
content: '请填写设备名称',
type: 'cancel'
})
return
}
if (this.ftype === '' || this.fdesc === '') {
this.$vux.alert.show({
content: '请填写故障描述信息',
type: 'cancel'
})
return
}
if (this.name === '' || this.mobile === '') {
this.$vux.alert.show({
content: '请填写报修人信息',
type: 'cancel'
})
return
}
if (this.company === '') {
this.$vux.alert.show({
content: '请填写报修人单位',
type: 'cancel'
})
return
}
this.fastrepairshow = true
},
findInfo() {
this.$http.get('/api/v1/devices/' + this.devseq + '/wechat?type=USER&role=INDV').then(response => {
this.devname = response.data.extname
this.isviwo = '是';
if (new Date(response.data['vwarranty']).getTime() < new Date().getTime()) {
const content = response.data.repaired ? '您报修的设备已超出保修服务约定，请联系您的供应商，或直接购买云帷保修服务，联系方式：18270332937（黄先生）' : '您报修的设备已超出保修约定，请及时联系您的供应商或原厂商核实相关情况，本次业务继续受理，可能需支付检测服务等相关费用，请知晓！';
this.$vux.confirm.show({
content,
cancelText: '继续报修按次付费',

showConfirmButton: false,
onConfirm: () => {
that.$vux.alert.show({
content: '暂不支持该服务'
})
}
})
}
}).catch(error => {
this.isviwo = '否';
this.$vux.alert.show({
content: '您填入的设备序列号不正确或为其他厂家设备，将按三方设备报修流程处理，可能将收取检修费用。(请检查并输入以“FH”或“VW”起始的编号)'
})
})
},
findSrvp() {
this.$http.get('/api/v1/devices/companies?value=' + this.producer).then(response => {
this.producerList = response.data
if (this.producerList.length === 1) {
if (this.producer !== this.producerList[0]) {
this.isProducer = true;
}
} else {
this.isProducer = true;
}
}).catch(error => {
this.$vux.toast.show({
text: JSON.parse(error.response.data.error_message).zh_string,
type: 'warn',
position: 'top',
time: '10000'
})
})
},
cancelAlarm() {
this.$vux.toast.hide();
},
chose(producer) {
this.producer = producer;
this.isProducer = false;
},
fileDel(index) {
this.imgRepairList.splice(index, 1)
this.imgList.content[0].path.splice(index, 1)
},
upload() {
const obj = {
photo: []
}

wx.chooseImage({
count: this.num - this.imgRepairList.length, // 默认9
sizeType: ['compressed'],
sourceType: ['album', 'camera'],
success: (res) => {
const localIds = res.localIds 
let i = 0;
const length = localIds.length;
const uploadImg = () => {
wx.uploadImage({
localId: localIds[i], // 需要上传的图片的本地ID，由chooseImage接口获得
isShowProgressTips: 1, // 默认为1，显示进度提示
success: (res) => {
this.$vux.loading.show({
text: 'Loading'
})
obj.photo.push(res.serverId)
i++
this.num--
if (i < length) {
uploadImg()
} else {
this.submitImage(obj)
}
console.log(res)
},
fail: (error) => {
console.log(error)
this.$vux.loading.hide()
}
})
}
uploadImg()
},
fail: (error) => {
this.$vux.loading.hide()
}
})
},
submitImage(photo) {
this.$http.post('/api/v1/photos/wechat', photo).then(res => {
this.imgList.content = [{path: []}]
this.imgList.content[0].path.push(...res.data)
if (this.imgList.content[0].path.length === 6) {
this.show = false
}
res.data.forEach(async (item, index) => {
const img = await this.$http.get('api/v1/photos?path=' + item.origin)
this.imgRepairList.push({src: 'data:image/jpeg;base64,' + img.data.value})
if (index + 1 === res.data.length) {
this.$vux.loading.hide()
}
})
}).catch(error => {
this.$vux.loading.hide()
this.$vux.toast.show({
text: JSON.parse(error.response.data.error_message).zh_string,
type: 'cancel',
time: '1000'
})
})
},
submit() {
if (!this.role) {
alert('您的身份不支持报修，请添加个人用户')
}
if (this.isSend) {
this.$vux.alert.show({
content: '订单已提交，请稍后',
type: 'cancel'
})
return
}
this.showLoading = true;
if (this.address.length === 0) {
this.showLoading = false
this.$vux.alert.show({
content: '请填写设备所在地',
type: 'cancel'
})
return
}
var address = {
address1: value2name(this.address, ChinaAddressV4Data),
address2: this.address2
}
address.address1 = address.address1.split(' ')
if (this.ftype === '' || this.fdesc === '') {
this.showLoading = false
this.$vux.alert.show({
content: '请填写故障描述信息',
type: 'cancel'
})
return
}
if (this.name === '' || this.mobile === '') {
this.showLoading = false
this.$vux.alert.show({
content: '请填写报修人信息',
type: 'cancel'
})
return
}
if (this.company === '') {
this.$vux.alert.show({
content: '请填写报修人单位',
type: 'cancel'
})
return
}
if (this.devname !== '' && this.devseq !== '' && this.ftype !== '' && this.fdesc !== '' && this.name !== ''
&& this.mobile !== '' && address.address1 !== '' && this.company) {
var that = this;
let token = localStorage.getItem('token')
let opid = localStorage.getItem('userid')
var newobj = {
headers: {
token: token,
opid: opid
}
}
if (this.name === this.save_info.name && this.mobile === this.save_info.mobile) {
if (!this.save_info.company) {
this.$http.put('/api/v1/users/' + opid + '/add_company_info', {
...this.userInfo,
company: this.company
}, newobj).then(response => {
})
}
}
var obj = {
account: opid,
role: this.role,
isviwo: this.isviwo === '是',
sevenday: this.sevenday,
devseq: this.devseq,
devname: this.devname,
devmodel: this.devmodel,
producer: this.producer,
buyfrom: this.buyfrom,
company: this.company,
name: this.name,
mobile: this.mobile,
ftype: this.ftype,
fdesc: this.fdesc,
province: address.address1[0],
city: address.address1[1],
district: address.address1[2],
address: address.address2,
fdetail: this.imgList,
lsmobile: this.lsmobile,
lservice: this.lservice,
enduser: this.enduser,
endmobile: this.endmobile,
reptype: this.reptype
}
this.isSend = true
this.$http.post("api/v1/normalrepairs", obj, newobj).then((res) => {
this.showLoading = false;
this.isSend = false
if (res.status == 201) {
that.$router.push({name: 'normalrepairslist'})
}
}).catch((error) => {
this.showLoading = false
this.isSend = false
if (error.response) {
if (error.response.data) {
that.$vux.alert.show({
title: '',
content: JSON.parse(error.response.data.error_message).zh_string,
})
} else {
that.$vux.toast.show({
text: '服务器错误，请稍后重试',
type: 'cancel',
time: '1000'
})
}
} else if (error.request) {
that.$vux.toast.show({
text: '服务器错误，请稍后重试',
type: 'cancel',
time: '1000'
})
} else {
that.$vux.toast.show({
text: '服务器错误，请稍后重试',
type: 'cancel',
time: '1000'
})
}
})
} else {
this.showLoading = false
this.$vux.alert.show({
content: '输入信息不完整，请补全后再提交',
type: 'cancel'
})
}
},
sys_click: function () {
var that = this
wx.ready(function () {
wx.checkJsApi({
jsApiList: ['scanQRCode'],
success: (res) => {

}
});
wx.scanQRCode({
needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
scanType: ["qrCode"], // 可以指定扫二维码还是一维码，默认二者都有
success: function (res) {
var result = res.resultStr; 

var url = result.substring(result.lastIndexOf('?') + 1, result.length);
var loc = url.substring(url.lastIndexOf('=') + 1, url.length);
AjaxPlugin.$http.get('/api/v1/devices/' + loc + '/wechat?type=USER&role=INDV')
.then((response) => {
if (response.data) {
that.devname = response.data.extname
that.devseq = response.data.seq
that.repaired = response.data.repaired
that.isviwo = '是'
if (new Date(response.data['vwarranty']).getTime() < new Date().getTime()) {
const content = that.repaired ? '您报修的设备已超出保修服务约定，请联系您的供应商，或直接购买云帷保修服务，联系方式：18270332937（黄先生）' : '您报修的设备已超出保修约定，请及时联系您的供应商或原厂商核实相关情况，本次业务继续受理，可能需支付检测服务等相关费用，请知晓！';
that.$vux.confirm.show({
content,
cancelText: '继续报修按次付费',

showConfirmButton: false,
onConfirm: () => {
that.$vux.alert.show({
content: '暂不支持该服务'
})
}
})
}
} else {
that.isviwo = '否'
that.$vux.alert.show({
title: '',
content: '无法识别编码,请确定是否扫描编码?',
})
}
})
.catch(err => {
that.isviwo = '否'
that.$vux.confirm.show({
title: '',
content: '您填入的设备序列号不正确或为其他厂家设备，将按三方设备报修流程处理，可能将收取检修费用。(请检查并输入以“FH”或“VW”起始的编号)',
onConfirm() {
that.devname = ''
that.devseq = ''
that.$refs.content.focus()
}
})
})
}
});

});
},
back() {
this.$router.push({name: 'normalrepairslist'})
},
sendCode() {
const obj = {
nationcode: '86',
mobile: this.mobile
}
if (this.mobile) {
this.$http.post('/api/v1/accounts/sms', obj)
.then((response) => {
if (response.data.result !== 0) {
this.$vux.alert.show({
title: '',
content: response.data.errmsg
})
}
})
localStorage.setItem('countDown', 60)
this.timeKeeping()
}
},
timeKeeping() {
this.smsDisabled = true
const interval = setInterval(() => {

let countDown = parseInt(localStorage.getItem('countDown'))

this.buttonText = countDown + '秒'

if (countDown === 0) {
clearInterval(interval)
localStorage.removeItem('countDown')
this.buttonText = '重新发送'
this.smsDisabled = false
} else {
countDown--
localStorage.setItem('countDown', countDown)
}
}, 1000)
},
onCancel() {
this.fastrepairshow = false
},
onConfirm() {
if (this.isSend) {
this.$vux.alert.show({
content: '订单已提交，请稍后',
type: 'cancel'
})
return
}
const info = {
code: this.code,
mobile: this.mobile
}
this.isSend = true
this.$http.put('/api/v1/accounts/checksms', info).then(response => {
const address = {
address1: value2name(this.address, ChinaAddressV4Data),
address2: this.address2
}
address.address1 = address.address1.split(' ')
if (this.ftype === '' || this.fdesc === '') {
this.showLoading = false
this.$vux.alert.show({
content: '请填写故障描述信息',
type: 'cancel'
})
return
}
if (this.name === '' || this.mobile === '') {
this.showLoading = false
this.$vux.alert.show({
content: '请填写报修人信息',
type: 'cancel'
})
return
}
if (this.address1 === '') {
this.showLoading = false
this.$vux.alert.show({
content: '请填写详细设备所在地',
type: 'cancel'
})
return
}
if (this.company === '') {
this.$vux.alert.show({
content: '请填写报修人单位',
type: 'cancel'
})
return
}
if (this.devname !== '' && this.devseq !== '' && this.ftype !== '' && this.fdesc !== '' && this.name !== '' && this.mobile !== '' && address.address1 !== '' && this.company) {
const data = {
isviwo: this.isviwo === '是',
sevenday: this.sevenday,
devseq: this.devseq,
devname: this.devname,
devmodel: this.devmodel,
producer: this.producer,
buyfrom: this.buyfrom,
company: this.company,
name: this.name,
mobile: this.mobile,
ftype: this.ftype,
fdesc: this.fdesc,
province: address.address1[0],
city: address.address1[1],
district: address.address1[2],
address: address.address2,
fdetail: this.imgList,
lsmobile: this.lsmobile,
lservice: this.lservice,
enduser: this.enduser,
endmobile: this.endmobile,
reptype: this.reptype,
openid: localStorage.getItem('openid'),
unionid: localStorage.getItem('unionid'),
nickname: localStorage.getItem('nickname'),
imgurl: localStorage.getItem('imgurl'),
otp:'official'

}
this.$http.post('api/v1/normalrepairs/fast_add_repair', data).then(response => {
localStorage.setItem('token', response.data.token)
localStorage.setItem('userid', response.data.userid)
this.$router.push({name: 'normalrepairslist'})
this.code = ''
this.isSend = false
setTimeout(() => {
this.fastrepairshow = false
this.showLoading = false
}, 1000)
}).catch(error => {
this.showLoading = false
this.isSend = false
this.$vux.alert.show({
title: '',
content: JSON.parse(error.response.data.error_message).zh_string,
})
})
} else {
this.isSend = false
alert('请填写必填项')
}
}).catch(error => {
this.showLoading = false
this.isSend = false
alert(JSON.parse(error.response.data.error_message).zh_string)
})
},
getSaveInfo() {
var openid = localStorage.getItem('openid')
const unionid = localStorage.getItem('unionid')
var that = this
this.$http.get('api/v1/wechat/' + unionid).then((res) => {



let account;
res.data.forEach(item => {
if (item.role === 'INDV') {
account = item.account
}
})
if (account) {
this.isFastReapir = false
localStorage.setItem('account', account)
that.$http.post('api/v1/wechat/' + unionid + '/token', {'account': account})
.then((res) => {
localStorage.setItem('token', res.data.token)
localStorage.setItem('userid', res.data.userid)
var opid = res.data.userid
var obj = {
headers: {
token: res.data.token,
opid: res.data.userid
}
}

that.$http.get('api/v1/accounts/' + opid, obj)
.then((response) => {
for (let i = 0; i < response.data.length; i++) {
if (response.data[i].type === 'INDV' || response.data[i].type === 'ENTP') {
that.role = response.data[i].type
break;
}
if (response.data[i].type === 'EXPT' || response.data[i].type === 'SRVP') {
that.isid = response.data[i].type
}
}
if (that.role === 'INDV' || that.role === 'ENTP') {
AjaxPlugin.$http.get('/api/v1/users/' + opid, obj)
.then(res => {
if (res.data.detail) {
that.userInfo = res.data.detail
delete this.userInfo.time
delete this.userInfo.result
delete this.userInfo.advice
that.userInfo.sequence = res.data.sequence
if (!(this.mobile || this.name)) {
that.name = res.data.detail.name
that.mobile = res.data.detail.mobile
that.company = res.data.detail.company
}
that.save_info = {
company: res.data.detail.company,
name: res.data.detail.name,
mobile: res.data.detail.mobile
}
console.log(that.save_info)
try {
var address = JSON.parse(res.data.detail.address)
that.address = address.address1.split(' ')
that.address2 = address.address2
} catch (e) {

}
}
})
}
})
.catch((error) => {
if (error.response) {
if (error.response.data) {
that.$vux.alert.show({
title: '',
content: JSON.parse(error.response.data.error_message).zh_string,
})
}
}
})

})
.catch((error) => {
if (error.response) {
if (error.response.data) {
that.$vux.alert.show({
title: '',
content: JSON.parse(error.response.data.error_message).zh_string,
})
}
}
})
} else {
this.isFastReapir = true
}
}).catch((error) => {
if (error.response) {
if (error.response.data) {
that.$vux.alert.show({
title: '',
content: JSON.parse(error.response.data.error_message).zh_string,
})
}
}
})
}
},
mounted() {
setTimeout(() => {
var timestamp = parseInt(new Date().getTime() / 1000)
var url
var u = navigator.userAgent
var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
this.$http.get('static/config.json').then(response => {
var config = response.data
url = isiOS ? config.host + global_.entryUrl.split('?')[0] : config.host + this.$route.path;
var noncestr = Math.random().toString(36).substr(2)
this.$http.get('/api/v1/wechat/jsApiTicket?timestamp=' + timestamp + '&noncestr=' + noncestr + '&url=' + url)
.then((response) => {
wx.config({
debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
appId: config.appId, // 必填，公众号的唯一标识
timestamp: timestamp, // 必填，生成签名的时间戳
nonceStr: noncestr, // 必填，生成签名的随机串
signature: response.data, // 必填，签名
jsApiList: ['chooseImage', 'previewImage', 'uploadImage', 'downloadImage', 'translateVoice', 'getLocalImgData', 'checkJsApi', 'scanQRCode'] 
})
wx.error((res) => {

})
})
.catch((error) => {
if (error.response) {
console.log(error.response.data)
} else if (error.request) {
console.log(error.request)
} else {
console.log('Error', error.message)
}
})
}, response => {
console.log('数据加载失败')
})
}, 500)
},
created() {
this.getSaveInfo();
if (this.$route.params.obj) {
this.devname = this.$route.params.obj.extname.replace('\n','')
this.devseq = this.$route.params.obj.seq
this.username = this.$route.params.username
this.findInfo()
}
},
}



// WEBPACK FOOTER //
// ./src/components/normalrepairs.vue